module.exports = __webpack_public_path__ + "static/img/87-3.a02bb7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/87-3.jpg
// module id = TL3q
// module chunks = 0